import styled, { css } from 'styled-components';
import breakpointsMinWidth from '../../../../../../../../styling/breakpointsMinWidth';

/**
 * This would prevent the default insertion in editor
 * by not allowing editor to be focused on drop
 */
export const Overlay = styled.div`
  height: 168px;
  position: absolute;
  width: 100%;
  top: 0;
  background: none;
  z-index: 1;
  display: ${(props) => (props.dragType ? 'block' : 'none')};
`;

const OrganizationDetailsWrapperSkill = ({ nodeType }) => {
  if (nodeType === 'skill_organization_details') {
    return css`
      display: grid;
      position: relative;
      margin: 20px 10px 12px 20px;
      grid-template-columns: 1fr min-content;
      grid-column-gap: 10px;

      @media ${breakpointsMinWidth.tabletSm} {
        grid-column-gap: 8px;
        margin: 12px 10px 12px 10px;
      }
      @media ${breakpointsMinWidth.tabletMd} {
        grid-column-gap: 10px;
        margin: 12px 12px 12px 10px;
      }
      @media ${breakpointsMinWidth.tabletLg} {
        grid-column-gap: 12px;
        margin: 16px 16px 12px 12px;
      }

      @media ${breakpointsMinWidth.desktopSm} {
        margin: 20px 20px 12px 16px;
      }

      @media ${breakpointsMinWidth.desktopMd} {
        margin: 20px 24px 12px 20px;
      }
    `;
  }

  return css``;
};

export const OrganizationDetailsWrapper = styled.div`
  display: grid;
  position: relative;
  margin: 16px 12px 12px 12px;
  grid-template-columns: 1fr min-content;
  grid-column-gap: 8px;
  ${(props) => OrganizationDetailsWrapperSkill(props)}

  @media ${breakpointsMinWidth.tabletSm} {
    grid-column-gap: 8px;
    margin: 12px 12px 12px 12px;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    grid-column-gap: 8px;
    margin: 12px 12px 12px 12px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    grid-column-gap: 12px;
    margin: 14px 14px 14px 14px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    grid-column-gap: 12px;
    margin: 16px 16px 16px 16px;
  }

  @media ${breakpointsMinWidth.desktopMd} {
    margin: 20px 20px 20px 20px;
  }
`;

export const OrganizationChildren = styled.div`
  display: grid;
  grid-template-columns: min-content repeat(2, 1fr);
  grid-template-rows: ${(props) =>
    props.nodeType === 'skill_organization_details' ? '1fr' : 'repeat(2,1fr)'};
  grid-column-gap: 10px;
  grid-row-gap: 8px;

  @media ${breakpointsMinWidth.tabletLg} {
    grid-column-gap: 14px;
    grid-row-gap: 20px;
  }

  @media ${breakpointsMinWidth.desktopSm} {
    grid-column-gap: 16px;
  }

  @media ${breakpointsMinWidth.desktopMd} {
    grid-column-gap: 20px;
  }
  ${(props) => {
    const { showImage } = props;
    if (!showImage) {
      return css`
        grid-column-gap: unset;
        @media ${breakpointsMinWidth.tabletLg} {
          grid-column-gap: unset;
        }

        @media ${breakpointsMinWidth.desktopSm} {
          grid-column-gap: unset;
        }

        @media ${breakpointsMinWidth.desktopMd} {
          grid-column-gap: unset;
        }
      `;
    }
    return null;
  }}
`;

export const OrganizationButtons = styled.div`
  display: flex;
  flex-direction: row;
  align-self: center;
  align-items: center;
  justify-content: center;
  user-select: none;
  gap: 5px;
  padding: 1px 4px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  box-sizing: border-box;
  border-radius: 4px;

  @media ${breakpointsMinWidth.tabletSm} {
    flex-direction: column;
    gap: 0px;
    padding: 0px 4px;
  }

  @media ${breakpointsMinWidth.tabletLg} {
    gap: 3px;
    padding: 3px 4px;
  }

  @media ${breakpointsMinWidth.desktopSm} {
    gap: 3px;
    padding: 4px 7px;
  }

  @media ${breakpointsMinWidth.desktopMd} {
  }
`;

export const Button = styled.span`
  pointer-events: auto;
  cursor: pointer;
`;

export const Export = styled(Button)``;

export const Delete = styled(Button)`
  cursor: pointer;
  &:hover {
    cursor: ${({ active }) => (active ? 'pointer' : 'not-allowed')};
  }
`;

export const AddButton = styled(Button)`
  &:hover {
    svg path:first-child {
      fill: #473880;
    }
  }
`;

export const CollapseBtn = styled(Button)`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0.5px solid #d3d3d3;
  box-sizing: border-box;
  border-radius: 50%;

  svg {
    transform: ${(props) =>
      !props.isCollapseChildren ? 'rotate(270deg)' : 'rotate(90deg)'};
    transition: transform 0.4s ease-in-out;
  }
`;

export const OrganizationCollapseButtons = styled.div`
  display: flex;
  align-self: center;
  justify-content: center;
  user-select: none;
`;
